import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-[#0F2B1F] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSI2MDAiIHZpZXdCb3g9IjAgMCAxMDAwIDYwMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCAwaDEwMDB2NjAwSDB6IiBmaWxsPSJub25lIi8+PC9zdmc+')] bg-cover bg-center"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-6">
              <span className="font-heading text-2xl text-white">
                yoybuy<span className="text-primary-400">.asia</span>
              </span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              {t("hero_subtitle")}
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t("footer_catalog")}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("footer_link_home")}
                </Link>
              </li>
              <li>
                <Link to="/article/yoybuy-sheet-guide" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("footer_link_article")}
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("category_shoes")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t("footer_guides")}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/yoybuy-sheet-guide" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("article_1_title")}
                </Link>
              </li>
              <li>
                <Link to="/article/yoybuy-sheet-guide" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("article_2_title")}
                </Link>
              </li>
              <li>
                <Link to="/article/yoybuy-sheet-guide" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("article_3_title")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">{t("footer_templates")}</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("nav_yoybuy_sheet")}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  {t("nav_buy_now")}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/50 text-sm hover:text-white/80 transition-colors">
                  Kaspreadsheet
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            {t("footer_copyright")}
          </p>
          <div className="flex items-center gap-3">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/40 hover:text-white/70 hover:border-white/40 transition-colors cursor-pointer">
              <i className="ri-telegram-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/40 hover:text-white/70 hover:border-white/40 transition-colors cursor-pointer">
              <i className="ri-whatsapp-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/40 hover:text-white/70 hover:border-white/40 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm"></i>
            </a>
          </div>
          <p className="text-white/40 text-xs">
            {t("footer_privacy")}
          </p>
        </div>
      </div>
    </footer>
  );
}